import client from './client';

/* ---------- Autenticación ---------- */
export const authAPI = {
  login: (username, password) =>
    client.post('/token/', { username, password }),
  register: (data) => client.post('/auth/register/', data),
  me: () => client.get('/auth/me/'),
  google: (credential, role, phone, whatsappQuoteOptIn) =>
    client.post('/auth/google/', {
      credential, role, phone, whatsapp_quote_opt_in: whatsappQuoteOptIn,
    }),
  setPassword: (password, currentPassword) =>
    client.post('/auth/set-password/', {
      password,
      current_password: currentPassword,
    }),
};

/* ---------- Categorías y servicios ---------- */
export const catalogAPI = {
  categories: () => client.get('/categories/'),
  services: (params = {}) => client.get('/services/', { params }),
  createCategory: (data) => client.post('/categories/', data),
  deleteCategory: (id) => client.delete(`/categories/${id}/`),
};

/* ---------- Obreros y maestros ---------- */
export const workerAPI = {
  search: (params = {}) => client.get('/workers/', { params }),
  filterOptions: (params = {}) => client.get('/workers/filter-options/', { params }),
  detail: (id) => client.get(`/workers/${id}/`),
  me: () => client.get('/workers/me/'),
  create: (data) =>
    client.post('/workers/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (id, data) =>
    client.patch(`/workers/${id}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

/* ---------- Proyectos ---------- */
export const projectAPI = {
  list: (params = {}) => client.get('/projects/', { params }),
  detail: (id) => client.get(`/projects/${id}/`),
  create: (formData) =>
    client.post('/projects/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

/* ---------- Reseñas y evaluaciones ---------- */
export const reviewAPI = {
  list: (params = {}) => client.get('/reviews/', { params }),
  create: (data) => client.post('/reviews/', data),
  supervisorList: (params = {}) =>
    client.get('/supervisor-evaluations/', { params }),
  supervisorCreate: (data) => client.post('/supervisor-evaluations/', data),
  supervisorUpdate: (id, data) =>
    client.patch(`/supervisor-evaluations/${id}/`, data),
};

/* ---------- Solicitudes de contacto / cotización ---------- */
export const contactAPI = {
  list: (params = {}) => client.get('/contact-requests/', { params }),
  create: (data) => client.post('/contact-requests/', data),
  updateStatus: (id, status) =>
    client.patch(`/contact-requests/${id}/`, { status }),
};

/* ---------- Administración ---------- */
export const adminAPI = {
  stats: () => client.get('/admin/stats/'),
  usersList: (params = {}) => client.get('/admin/users/', { params }),
  createUser: (data) => client.post('/admin/users/create/', data),
  updateUser: (id, data) => client.patch(`/admin/users/${id}/`, data),
  deleteUser: (id) => client.delete(`/admin/users/${id}/`),
  clientsList: (params = {}) => client.get('/admin/clients/', { params }),
  workersList: (params = {}) => client.get('/admin/workers/', { params }),
  projectsReport: (params = {}) => client.get('/admin/projects-report/', { params }),
};

export default client;
